function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m15143 3686-7 7 7-7-7-7 7 7 7-7-7 7 7 7z",
  "data-name": "Union 65",
  style: {
    fill: "none",
    stroke: "#000",
    strokeWidth: "1.3px"
  },
  transform: "translate(-15126.998 -3669.998)"
}));
export default SvgIconClose;